/**
 * Request body for initiating a download request.
 */
export interface DownloadRequestBody {
  genRequestId: string;
  index: number;
  sizeName: string;
  projectCode?: string;
  notes?: string;
  agreementId?: string;
  /** Selected original-image size name (Gen BuyCard). */
  originalSizeName?: string;
}

export enum DownloadStatus {
  /**
   * A download request has been initiated, waiting for download to complete.
   */
  DOWNLOADING = 'DOWNLOADING',
  /**
   * Polling for download, service is upscaling the image.
   */
  UPSCALING = 'UPSCALING',
  /**
   * Download is complete, ready to download.
   */
  DOWNLOADED = 'DOWNLOADED',
  /**
   * Download has failed.
   */
  FAILED = 'FAILED',
}

export type DownloadRequestStatus = keyof typeof DownloadStatus;

/**
 * Response given by ContentService when a download is complete.
 */
export interface DownloadData {
  downloadId: number;
  customMediaId: string;
  url: string;
}
/**
 * Response given by ContentService when a download is complete.
 */
export interface DownloadCompleteSvcResponse {
  status: 200;
  data: DownloadData;
}
/**
 * Response given by ContentService when a download is in progress.
 */
export interface DownloadEmptySvcResponse {
  status: 202;
}
/**
 * Response given by download controller (NestAPI) when a download is NOT complete.
 */
export interface DownloadNotComplete {
  status: DownloadStatus;
  startedAt?: number;
}
/**
 * Response given by download controller (NestAPI) when a download is complete.
 */
export interface DownloadComplete extends DownloadNotComplete {
  status: DownloadStatus.DOWNLOADED;
  downloadId: number;
  customMediaId: string;
  url: string;
}

export type DownloadState = DownloadComplete | DownloadNotComplete | null;
